export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2025.e167c202.pdf";